const DEFAULT_LANG = 'it'

const SUPPORTED_LANGUAGES = ['it','en']

export { DEFAULT_LANG, SUPPORTED_LANGUAGES }